import { opportunities as initialOpportunities } from '@/mocks';
import type { Opportunity } from '@/mocks';

let _opportunities: Opportunity[] = [...initialOpportunities];
const _listeners = new Set<() => void>();

function notify() {
  _listeners.forEach(l => l());
}

export const opportunityStore = {
  getAll: (): Opportunity[] => [..._opportunities],

  add: (opp: Omit<Opportunity, 'id'>): Opportunity => {
    const newOpp: Opportunity = { ...opp, id: Date.now() };
    _opportunities = [..._opportunities, newOpp];
    notify();
    return newOpp;
  },

  updateStage: (id: number, stage: Opportunity['stage']): void => {
    _opportunities = _opportunities.map(o => o.id === id ? { ...o, stage } : o);
    notify();
  },

  subscribe: (listener: () => void): (() => void) => {
    _listeners.add(listener);
    return () => { _listeners.delete(listener); };
  },
};
